import { useActiveSignupSponsor } from './useActiveSignupSponsor';
import { useLinkIncentive } from './useLinkIncentive';
import { showRewards } from '../rewards/show-rewards';
import { useSignupFlowStore } from '../stores/signup-flow-store';

/** Whether this step shows the rewards surfaces, by the shared rewards rule. */
export function useShowRewards(): boolean {
  const sponsor = useActiveSignupSponsor();
  const eligibilityStatus = useSignupFlowStore((state) => state.eligibilityStatus);
  const incentive = useLinkIncentive();
  return showRewards(sponsor.isSuccess ? sponsor.data : undefined, eligibilityStatus, incentive);
}
